import VideoActions from 'actions/video_actions';
import VideoStore   from 'stores/video_store';

export default {
  setCurrentTime(time) {
    if(VideoStore.state.isEnded) { // desktop
      VideoActions.replay();
    }
    VideoActions.setCurrentTime(time);
  }
};



/** WEBPACK FOOTER **
 ** ./modules/mixins/ios_video_set_current_time.js
 **/